import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import server, { uploadServer } from "../../api/server";
import { useForm } from "react-hook-form";
import { handleImage } from "../../helpers";

const AboutUsIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "نبذة عنا",
				breadcrumb: "المعلومات",
				button: {
					show: false,
					text: "اضافة معلومة جديدة",
					link: "/siteinfo/aboutUs/create",
				},
			})
		);
		try {
			const pageData = await server(cookie).get("/pages/about-us");
			setData(pageData.data.data.page.sections);
			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	const handleDelete = postID => {
		axios
			.delete(
				`${process.env.REACT_APP_API_URL}/pages/about-us/sections/${postID}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	useEffect(() => {
		onStart();
	}, []);

	return (
		<section>
			{loading && <Loader />}
			<section>
				<div className="row">
					{data
						?.filter(e => e?.slug != "file")
						// ?.filter(
						// 	e =>
						// 		// e => e?.slug != "descriptions"
						// 		e?.slug == "certificates" ||
						// 		e?.slug == "ma-alsltan-ant-alksban-aboutUs"
						// )
						?.map(post => (
							<div className="col-md-3" key={post.slug}>
								<div className="serviceItem">
									{/* <button onClick={() => handleDelete(post.slug)}>
									<i className="fas fa-trash"></i>
								</button> */}
									<Link to={`/siteinfo/aboutUs/show/${post?.slug}`}>
										{post?.image && (
											<img
												src={`${process.env.REACT_APP_MAIN_URL}/${post?.image}`}
												alt={post?.sectionTitle?.ar || ""}
											/>
										)}
										{post?.sectionTitle?.ar && (
											<h1>{post?.sectionTitle?.ar || ""}</h1>
										)}
										{post?.description?.ar && (
											<p>{post?.description?.ar || ""}</p>
										)}
									</Link>
								</div>
							</div>
						))}
				</div>
				<FileForm file={data?.find(e => e?.slug == "file")?.file} />
			</section>
		</section>
	);
};

const FileForm = ({ file }) => {
	const [loading, setLoading] = useState(false);

	const [pictureImg, setPictureImg] = useState(file);

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		reset,
	} = useForm();

	const submitHandler = async data => {
		setLoading(true);
		try {
			const dataForm = new FormData();
			dataForm.append("file", data.pictureUrl[0]);
			console.log("data >>> ", data);

			const imageResponse = await uploadServer(cookie).post(
				"/upload",
				dataForm
			);

			const finalData = {
				file: imageResponse.data.data.file,
			};

			const dataResponse = await server(cookie).put(
				"/pages/about-us/sections/file",
				{
					section: finalData,
				}
			);
			reset();
			setPictureImg(file);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const handlePicture = () => {
		const tempValue = getValues("pictureUrl");
		if (tempValue.length < 1) return;
		const blobUrl = URL?.createObjectURL(tempValue?.[0]);
		setValue("picturePath", blobUrl);
		setPictureImg(blobUrl);
	};
	const handleDownload = async (url, filename) => {
		const response = await fetch(url);
		const blob = await response.blob();
		const blobUrl = window.URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = blobUrl;
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(blobUrl);
	};
	return (
		<form onSubmit={handleSubmit(submitHandler)}>
			{loading && <Loader />}
			<div className="row">
				<div className="col-md-12">
					<div className="card">
						<div className="card-body">
							<div className="form-item">
								<label htmlFor="picture">بروفايل الشركة</label>
								<input
									type="file"
									id="picture"
									{...register("pictureUrl", {
										required: true,
										onChange: () => handlePicture(),
									})}
									accept="application/*"
								/>
								<br />
								<br />
								<a
									// href={`${process.env.REACT_APP_MAIN_URL}${file}`}
									// target="_blank"

									href="#"
									onClick={e => {
										e.preventDefault();
										handleDownload(
											process.env.REACT_APP_MAIN_URL + file?.path,
											file?.originalname
										);
									}}
								>
									عرض الملف
								</a>
								{/* <img
									src={handleImage(pictureImg || file)}
									alt="avatar"
									className="imagePreview-2"
								/> */}
							</div>
						</div>
					</div>
					<input
						type="text"
						name=""
						id=""
						style={{ display: "none" }}
						{...register("picturePath")}
					/>
					<div className="form-item mt-3">
						<button className="bt bt-success btn-block">ارسال</button>
					</div>
				</div>
			</div>
		</form>
	);
};

export default AboutUsIndex;
